import { styled } from "styled-components";

export const Body = {};

export const Div = styled.div`
  display: flex;
`;
